export default __webpack_public_path__ + "f7d04f0.png";